/** Hell, dunkel oder dem System folgen — die Wahl bleibt im Browser. */
export type Theme = "system" | "light" | "dark";

const KEY = "postfach-theme";

export function gespeichertesTheme(): Theme {
  try {
    const t = localStorage.getItem(KEY);
    if (t === "light" || t === "dark") return t;
  } catch { /* privater Modus */ }
  return "system";
}

export function themeAnwenden(t: Theme) {
  const root = document.documentElement;
  if (t === "system") root.removeAttribute("data-theme");
  else root.setAttribute("data-theme", t);
  try {
    if (t === "system") localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, t);
  } catch { /* privater Modus */ }
}
